import ListItem from '../../utils/ListItem';

function AircraftListItem(props) {
  const ac = props.ac || {};
  const primary = [ac.AcModel, ac.AcName].filter(Boolean).join(' — ') || 'Unnamed Aircraft';
  const secondary = [
    ac.AcSerial && `Serial: ${ac.AcSerial}`,
    ac.MacrNum && `MACR: ${ac.MacrNum}`,
  ].filter(Boolean).join(' • ');

  return (
    <ListItem
      primary={primary}
      secondary={secondary || null}
    />
  );
}

export default AircraftListItem;
